import { defineComponent as r, computed as s, createBlock as d, openBlock as f, unref as m, createSlots as u, withCtx as i, renderSlot as l } from "vue";
import { COMPONENT_NAME as c } from "./highrise174.mjs";
import { NPerformantEllipsis as g } from "./highrise439.mjs";
const h = r({
  name: c.ELLIPSIS,
  inheritAttrs: !1
}), C = /* @__PURE__ */ r({
  ...h,
  props: {
    id: {
      type: String,
      default: "hr-ellipsis-id"
    },
    expandOn: {
      type: String
    },
    lineClamp: {
      type: Number,
      default: 1
    },
    tooltipProps: {
      type: Object,
      default: () => ({})
    },
    showTooltip: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const e = t, n = {
      backgroundColor: "var(--gray-900)",
      color: "#fff",
      borderRadius: "4px",
      padding: "8px"
    }, p = {
      fontSize: "var(--font-size-sm)",
      lineHeight: "var(--line-height-sm)",
      fontWeight: "var(--font-weight-medium)"
    }, a = s(() => typeof e.tooltipProps == "object" && e.tooltipProps ? { ...e.tooltipProps, style: n, contentStyle: p } : e.tooltipProps);
    return (o, y) => (f(), d(m(g), {
      id: t.id,
      "expand-trigger": t.expandOn,
      "line-clamp": t.lineClamp,
      tooltip: t.showTooltip ? a.value : !1
    }, u({
      default: i(() => [
        l(o.$slots, "default")
      ]),
      _: 2
    }, [
      o.$slots.tooltip ? {
        name: "tooltip",
        fn: i(() => [
          l(o.$slots, "tooltip")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "expand-trigger", "line-clamp", "tooltip"]));
  }
});
export {
  C as default
};
